import React from 'react';
import Select from 'react-select';
import { Flex } from '@chakra-ui/react';
import { useAnalyticsFilters } from '@/hooks/useAnalyticsFilters';
import { colourStylesChannel, colourStylesDepartment } from './filterStyles';
import { UserRole } from '@/api/auth/types';

interface AnalyticsFiltersProps {
  isActive?: boolean;
  showChannel?: boolean;
  showDepartment?: boolean;
  gap?: string;
  additionalFilters?: React.ReactNode;
  exportButton?: React.ReactNode;
  noDefaultFilters?: boolean;
}

export const AnalyticsFilters: React.FC<AnalyticsFiltersProps> = ({
  isActive = true,
  showChannel = true,
  showDepartment = true,
  gap = "20px",
  additionalFilters,
  exportButton,
  noDefaultFilters = false,
}) => {
  const {
    channelList,
    currentChannelValue,
    handleChannelChange,
    departmentList,
    currentDepartmentValue,
    handleDepartmentChange,
  } = useAnalyticsFilters(isActive);


  const userRole = localStorage.getItem("role");

  return (
    <Flex gap={gap} marginTop="10px" flexWrap="wrap" padding="16px" bgColor="white" borderRadius="8px" border="1px solid #e1e7ef">
      {additionalFilters}
      
      {showChannel && !noDefaultFilters && (
        <Select
          menuPosition="fixed"
          className="basic-single"
          classNamePrefix="select"
          isSearchable={false}
          name="channel"
          styles={colourStylesChannel}
          options={channelList}
          placeholder="Канал подбора"
          value={currentChannelValue}
          onChange={handleChannelChange}
          isDisabled={userRole === UserRole.RECRUITER || userRole === UserRole.DEPARTMENT_MANAGER}
        />
      )}

      {showDepartment && !noDefaultFilters && (
        <Select
          menuPosition="fixed"
          className="basic-single"
          classNamePrefix="select"
          isSearchable={false}
          name="department"
          styles={colourStylesDepartment}
          options={departmentList}
          placeholder=""
          value={currentDepartmentValue}
          onChange={handleDepartmentChange}
          isDisabled={userRole === UserRole.RECRUITER}
        />
      )}
      
      {exportButton}
    </Flex>
  );
};
